import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { DurationPipe } from './pipes/duration.pipe';
import { ReplacePipe } from './pipes/replace.pipe';

@NgModule({
  declarations: [AppComponent, DurationPipe, ReplacePipe],
  imports: [CommonModule],
  providers: [],
  exports: [DurationPipe, ReplacePipe],
  bootstrap: [AppComponent],
})
export class SharedModule {}
